/*  ========================================================================
    # Components - Sections - How It Works
    ========================================================================  */

// Dependencies
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSwipeable } from "react-swipeable";

// Assets
import ChevronLeft from "@images/svg/ui/chevron-left.svg";
import ChevronRight from "@images/svg/ui/chevron-right.svg";
import Gluehbirne from "@images/svg/how-it-works/01-gluehbirne.svg";
import Laptop from "@images/svg/how-it-works/02-laptop.svg";
import Pokal from "@images/svg/how-it-works/03-pokal.svg";

const HowItWorks = () => {
  const shifterRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [shifterTranslateX, setSliderTranslateX] = useState(null);

  const adjustSlider = useCallback(() => {
    const shifterRect = shifterRef.current.getBoundingClientRect();
    setSliderTranslateX({
      transform: `translateX(-${shifterRect.width * currentSlide}px)`,
    });
  }, [shifterRef, setSliderTranslateX, currentSlide]);

  const navigateLeft = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const navigateRight = () => {
    if (currentSlide < 2) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => navigateRight(),
    onSwipedRight: () => navigateLeft(),
  });

  useEffect(() => adjustSlider(), [currentSlide]);
  useEffect(() => {
    window.addEventListener("resize", adjustSlider);
    return () => window.removeEventListener("resize", adjustSlider);
  }, [adjustSlider]);

  return (
    <section id="how-it-works" className="s-how-it-works">
      <div className="container">
        <div className="s-how-it-works__text">
          <h2 className="u-text-purple">So geht&apos;s:</h2>
          <p>
            Du bist <b>zwischen 18 und 29 Jahre alt</b> und möchtest die Zukunft
            Deiner Region mitgestalten? Teile uns Deine Idee mit und nutze die
            Chance auf ein <b>Preisgeld in Höhe von bis zu 5.000 €</b> zur
            Umsetzung Deiner Idee. Insgesamt werden 10.000 € auf die Gewinner
            verteilt.
          </p>
        </div>

        <div className="s-how-it-works__slider" {...swipeHandlers}>
          <div
            className="s-how-it-works__slider-shifter"
            style={shifterTranslateX}
            ref={shifterRef}
          >
            <div className="s-how-it-works__slide-wrapper">
              <div
                data-offset={0 - currentSlide}
                className="s-how-it-works__slide"
              >
                <div className="s-how-it-works__icon">
                  <Gluehbirne />
                </div>
                <h3>Ideen einreichen</h3>
                <p>
                  Reiche Deine Ideen bis zum <strong>30. Juni 2025</strong> hier
                  auf der Website ein. Gerne kannst Du auch Bilder hochladen,
                  die uns helfen, Deine Ideen zu verstehen.
                </p>
              </div>
            </div>
            <div className="s-how-it-works__slide-wrapper">
              <div
                data-offset={1 - currentSlide}
                className="s-how-it-works__slide"
              >
                <div className="s-how-it-works__icon">
                  <Laptop />
                </div>
                <h3>Jurysitzung</h3>
                <p>
                  Hier stellt Ihr die zehn besten Ideen virtuell der Jury vor.
                  Halte Dir also schon mal den <b>14. August 2025</b> von 14:00
                  bis 17:00 Uhr frei!
                </p>
              </div>
            </div>
            <div className="s-how-it-works__slide-wrapper">
              <div
                data-offset={2 - currentSlide}
                className="s-how-it-works__slide"
              >
                <div className="s-how-it-works__icon">
                  <Pokal />
                </div>
                <h3>Preisverleihung</h3>
                <p>
                  Die drei Gewinner werden am <b>17. September 2025</b> in
                  Frankfurt am Main prämiert – wir drücken Dir die Daumen!
                </p>
              </div>
            </div>
          </div>
          <button
            className="s-how-it-works__control s-how-it-works__control--left"
            onClick={navigateLeft}
            disabled={currentSlide === 0}
          >
            <ChevronLeft />
          </button>
          <button
            className="s-how-it-works__control s-how-it-works__control--right"
            onClick={navigateRight}
            disabled={currentSlide === 2}
          >
            <ChevronRight />
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
